import { GridColDef } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import { paths } from 'src/routes/paths';

export interface LpCouponsTableColumnsProps {}

export const getLpCouponsColumns = (roles?: string[]): GridColDef[] => [
  { field: 'name', headerName: 'Nome', flex: 1, disableColumnMenu: true },
  {
    field: 'eventName',
    headerName: 'Evento',
    disableColumnMenu: true,
    flex: 1,
    renderCell: (params) => {
      const { lpEventsData, eventName } = params.row;
      return roles?.includes('cn_admin') ? (
        <Link
          color="black"
          style={{
            color: 'inherit',
            cursor: 'pointer',
          }}
          to={paths.dashboard.lpEventDetails(lpEventsData.eventId)}
          onClick={(e) => e.stopPropagation()}
        >
          {eventName}
        </Link>
      ) : (
        <>{eventName}</>
      );
    },
  },
  { field: 'totalQuantity', headerName: 'Quantidade total', flex: 1, disableColumnMenu: true },
  { field: 'availableQuantity', headerName: 'Estoque', flex: 1, disableColumnMenu: true },
  {
    field: 'creatorName',
    headerName: 'Criado por',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (params) => {
      const { creatorName } = params.row;
      const { creatorId } = params.row.lpEventsData;
      return roles?.some((role) => ['cn_admin', 'lp_promoter'].includes(role)) ? (
        <Link
          color="black"
          style={{
            color: 'inherit',
            cursor: 'pointer',
          }}
          to={paths.dashboard.lpEventsParticipantDetails(creatorId)}
          onClick={(e) => e.stopPropagation()}
        >
          {creatorName}
        </Link>
      ) : (
        <>{creatorName}</>
      );
    },
  },
  { field: 'startDate', headerName: 'Data de Início', flex: 1, disableColumnMenu: true },
  { field: 'endDate', headerName: 'Data de Fim', flex: 1, disableColumnMenu: true },
  { field: 'createdAt', headerName: 'Criado em', flex: 1, disableColumnMenu: true },
];
